var stripComments = { exports: {} };
export {
  stripComments as __module
};
//# sourceMappingURL=stripComments.js.map
